var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.wrapper
  }, [_c('h2', {
    class: _vm.$style.heading
  }, [_vm._v("\n      Сменить пароль\n    ")]), _vm._v(" "), _c('VForm', {
    class: _vm.$style.formContainer
  }, [_c('FormFieldPassword', {
    attrs: {
      "label": "Новый пароль",
      "field": "newPassword",
      "show-pass": _vm.showPass.newPassword
    },
    on: {
      "clickAppend": function clickAppend($event) {
        return _vm.toggleShowPass('newPassword');
      }
    }
  }), _vm._v(" "), _c('FormFieldPassword', {
    attrs: {
      "label": "Новый пароль (еще раз)",
      "field": "confirmPassword",
      "same-as": "newPassword",
      "show-pass": _vm.showPass.confirmPassword
    },
    on: {
      "clickAppend": function clickAppend($event) {
        return _vm.toggleShowPass('confirmPassword');
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.wrapperControls
  }, [_c('SButton', {
    attrs: {
      "size": "default",
      "theme": "secondary"
    },
    on: {
      "click": _vm.backToProfileEditing
    }
  }, [_vm._v("\n      Отменить\n    ")]), _vm._v(" "), _c('SButton', {
    attrs: {
      "size": "default",
      "theme": "primary",
      "loading": _vm.loader
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("\n      Сменить пароль\n    ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };